import '../tracks/actual_frames';
import '../tracks/android_log';
import '../tracks/async_slices';
import '../tracks/chrome_slices';
import '../tracks/counter';
import '../tracks/cpu_freq';
import '../tracks/cpu_profile';
import '../tracks/cpu_slices';
import '../tracks/debug_slices';
import '../tracks/expected_frames';
import '../tracks/generic_slice_track';
import '../tracks/heap_profile';
import '../tracks/perf_samples_profile';
import '../tracks/process_scheduling';
import '../tracks/process_summary';
import '../tracks/thread_state';